// tslint:disable-next-line: no-namespace
export namespace SpintrTypes {
    /* * * * *
     * Enums *
     * * * * */
    export enum UserState {
        Undefined = 0,
        Online = 1,
        Inactive = 2,
        Offline = 3,
        Busy = 4,
    };

    export enum SpintrApp {
        Media = 1,
        Blogs = 2,
        Absence = 3,
        Forms = 4,
        News = 5,
        Calendars = 6,
        Files = 7,
        Organisation = 8,
        Wikis = 9,
        Booking = 10,
        RSS = 11,
        Birthdays = 13,
        Tags = 14,
        EmergencyAlerts = 15,
        Newsletters = 16,
        Todos = 17,
        Instagram = 18,
        Competence = 19,
        DeviationManager = 20,
        ImprovementsSuggestions = 21,
        Dashboard = 22,
        OperatingInfo = 23,
        Newsletter = 24,
        Notes = 25,
        QA = 26,
        ActivityLog = 27,
        Suppliers = 28,
        Slack = 29,
        Coworkers = 30,
        SystemStatus = 31,
        Academy = 32,
        Products  = 33,
        Planner = 34,
        StatisticsDashboard = 35,
        
        QualityHub = 37,
    }
    
    export enum PlannerItemType {
        General = 1,
        Campaign = 2,
        Course = 3,
        Delivery = 4,
        Event = 5,
        Inventory = 6,
        Maintenance = 7,
        Release = 8,
        WorkShift = 9,
    };

    export enum PlannerCampaignFileType {
        CampaignMaterial = 1,
        CampaignPlan = 2,
        LegalComplianceInfo = 3,
    };

    export enum PlannerCourseFileType {
        CourseMaterial = 1,
        CoursePlan = 2,
    };

    export enum PlannerDeliveryFileType {
        DeliveryPlan = 1,
        ProofOfDelivery = 2,
    };

    export enum PlannerEventFileType {
        Agenda = 1,
        EventMaterial = 2,
        LogisticsInfo = 3,
    };

    export enum PlannerEventParticipantStatus {
        Invited = 1,
        Accepted = 2,
        Rejected = 3,
        Tenative = 4,
    };

    export enum PlannerInventoryFileType {
        InventoryPlan = 1,
        InventoryReport = 2,
    };

    export enum PlannerMarketingChannel {
        SocialMedia     = 1,
        Email           = 2,
        Store           = 3,
        Convention      = 4,
        OnlineAds       = 5,
        PopupEvent      = 6,
        TV              = 7,
        Radio           = 8,
        Print           = 9,
        Outdoor         = 10,
        Influencer      = 11,
    };

    export enum PlannerInventoryMethod {
        Manual = 1,
        Digital = 2,
        Automatic = 3,
    };

    export enum PlannerItemResourceType {
        Personnel = 1,
        Equipment = 2,
        Material = 3,
    };

    export enum PlannerMaintenanceFileType {
        MaintenancePlan = 1,
        MaintenanceReport = 2,
    };

    export enum PlannerReleaseFileType {
        RolloutPlan = 1,
        MarketingMaterial = 2,
        LaunchStrategy = 3,
    };

    export enum CompletionType {
        Expansion = 1, // Expects length
        Correction = 2,
        Reformulation = 3,
        Summarization = 4, // Expects type (list, sentence, paragraph)
        TonalityChange = 5, // Expects tone (friendly, professional, funny, warm, educational)
        TitleSuggestion = 6,
        IntroductionSuggestion = 7,
        HeadingSuggestion = 8,
    }    

    export enum LayoutType {
        StartPage = 1,
    }

    /**
     * A flags enum representing the status of content.
     */
    export enum ContentStatus {
        Published   = 1 << 0,
        Draft       = 1 << 1,
        Deleted     = 1 << 2,
        Expired     = 1 << 3
    }

    export const SpintrAppInfo = {
        Media: { moduleKey: "gallerytop", icon: "Photo2", id: 1 },
        Blogs: { moduleKey: "blogtop", icon: "Blog", id: 2 },
        Absence: { moduleKey: "absence", icon: "Vacation", id: 3 },
        Forms: { moduleKey: "", icon: "Questionnaire", id: 4 },
        News: { moduleKey: "news", icon: "News", id: 5 },
        Calendars: { moduleKey: "calendar", icon: "Calendar", id: 6 },
        Files: { moduleKey: "files", icon: "FileSystem", id: 7 },
        Organisation: { moduleKey: "departmenttop", icon: "EngineeringGroup", id: 8 },
        Wikis: { moduleKey: "wikis", icon: "BulletedTreeList", id: 9 },
        Booking: { moduleKey: "bookings", icon: "Car", id: 10 },
        RSS: { moduleKey: "", icon: "ViewList", id: 11 },
        Birthdays: { moduleKey: "", icon: "BirthdayCake", id: 13 },
        Tags: { moduleKey: "", icon: "TagGroup", id: 14 },
        EmergencyAlerts: { moduleKey: "", icon: "ReportAlert", id: 15 },
        Newsletters: { moduleKey: "", icon: "MailSchedule", id: 16 },
        Todos: { moduleKey: "todo", icon: "CheckList", id: 17 },
        Instagram: { moduleKey: "", icon: "Photo2", id: 18 },
        Competence: { moduleKey: "", icon: "KeyboardClassic", id: 19 },
        DeviationManager: { moduleKey: "", icon: "KeyboardClassic", id: 20 },
        ImprovementsSuggestions: { moduleKey: "", icon: "KeyboardClassic", id: 21 },
        Dashboard: { moduleKey: "", icon: "GoToDashboard", id: 22 },
        OperatingInfo: { moduleKey: "operatinginfo", icon: "AlertSolid", id: 23 },
        Newsletter: { moduleKey: "", icon: "MailSchedule", id: 24 },
        Notes: { moduleKey: "notes", icon: "EditNote", id: 25 },
        QA: { moduleKey: "qa", icon: "QandA", id: 26 },
        ActivityLog: { moduleKey: "activitylog", icon: "AnalyticsLogo", id: 27 },
        Suppliers: { moduleKey: "suppliers", icon: "Suitcase", id: 28 },
        Slack: { moduleKey: "", icon: "CannedChat", id: 29 },
    }

    export enum SamlCertificateType
    {
        IdentityProviderSigning = 1,
        IdentityProviderEncryption = 2,
        ServiceProviderSigning = 3,
        ServiceProviderEncryption = 4
    };

    export enum WidgetType {
        Any = 0,
        KeyPointIndicator = 1,
        LineChart = 2,
        BarChart = 3,
        PieChart = 4,
        CircularChart = 5,
        List = 6,
        ListOneColumn = 7,
        GagueChart = 8,
        Leaderboard = 9,
        Table = 10,
        UpcomingEvents = 11
    }

    export enum DataAppAuthenticationMethod {
        AnonymousAccess = 1,
        BasicAuthentication = 2,
        OAuth2ClientCredentials = 3,
        CustomHeader = 4,
        CustomQueryString = 5,
        OAuth1ClientCredentials = 6,

        SpintrKPI = 101,
        Fortnox = 102,
        Teamtailor = 103,
        Learnster = 106,
        SpintrCalendar = 112
    }

    export enum HeaderSearchBarMode {
        Search = 1,
        Assistant = 2,
    }

    export enum Language {
        Swedish         = 1,
        Norweigan       = 2,
        English         = 3,
        German          = 4,
        Finnish         = 5,
        Danish          = 6,
        Italian         = 7,
        Spanish         = 8,
        French          = 9,
    }

    export enum StatusFrameFonts {
        PageDefault = 1,
        Merriweather = 2,
        IndieFlower = 3,
        Pacifico = 4,
    }

    export enum UberType {
        Unknown = 0,
        User = 1,
        Department = 2,
        Status = 3,
        Bookmark = 4,
        Like = 5,
        Comment = 6,
        File = 7,
        Office = 8,
        TextPage = 9,
        NewsArticle = 10,
        Event = 11,
        Gallery = 12,
        Image = 13,
        ImageTag = 14,
        Wiki = 15,
        WikiArticle = 16,
        WikiSection = 17,
        WikiDiscussion = 18,
        WikiSectionBackup = 19,
        Blog = 20,
        BlogPost = 21,
        UserSkill = 22,
        UserInterest = 23,
        UserEmployer = 24,
        FileVersion = 25,
        Group = 26,
        GroupMember = 27,
        Milestone = 28,
        Task = 29,
        CRM = 30,
        CRMNote = 31,
        CRMTodo = 32,
        Poll = 33,
        PollOption = 34,
        PollAnswer = 35,
        UserEducation = 36,
        Conversation = 37,
        RssEntry = 38,
        MSRoutineCopy = 39,
        MSDeviation = 40,
        MSRoutine = 41,
        FileExtra = 42,
        MSAction = 43,
        Role = 44,
        BookingResource = 45,
        TextPageUpdate = 46,
        Survey = 47,
        EmergencyMessage = 48,
        ImagePost = 49,
        CaneaFile = 50,
        TodoList = 51,
        TargetGroup = 52,
        TodoDepartmentChecked = 53,
        HiddenPost = 54,
        QA = 55,
        Note = 56,
        TeaserBox = 57,
        FileCategory = 60,
        PlanningCategory = 61,
        PlanningItemTodo = 63,
        Shortcut = 62,
        PlanningItem = 64,
        Company = 65,
        ChatMessage = 70,
        UserEmployment = 71,
        StoryFeed = 72,
        StoryItem = 73,
        ExternalFile = 74,
        Supplier = 75,
        OperatingInfo = 76,
        SupplierGroup = 77,
        SupplierExternalMessage = 78,
        SupplierRoleData = 79,
        SupplierExternalFile = 80,
        BusinessDeal = 81,
        SomethingFun = 82,
        Kudos = 83,
        SystemStatusResource = 84,
        SystemStatus = 85,
        AcademyCourse = 86,
        AcademyLesson= 87,
        Product = 88,
        PlannerItem = 90,
    }

    export enum Privilege {
        CreatePages = 1001,
        CreateSubPages = 1002,
        EditPage = 1003,
        DeletePage = 1004,
        CreateAndEditNewsArticles = 2001,
        CanViewFileCategory = 3001,

        IsQualityHubAdministrator  = 4001,
        IsLearningAdministrator = 5001,
        IsPlannerHubAdministrator = 7001,
        CanUploadAndCreateFoldersInMedia = 8001,
    }

    export enum StatusType {
        Text = 0,
        Video = 1,
        Share = 2,
        Bookmark = 3,
        Frame = 4,
        File = 5,
        Question = 6,
        SomethingFun = 7,
        BusinessDeal = 8,
        Kudos = 9,
        Mirror = 10,
        SystemStatus = 11,
    }

    export enum StatusFrameBackground {
        Gradient = 1,
        Image = 2,
    }

    export enum StatusFrameGradientDirection {
        Top = 1,
        Right = 2,
        Bottom = 3,
        Left = 4,
    }

    export enum GalleryType {
        Central = 0,
        Public = 1,
        Personal = 2,
        Mobile = 3,
        Profile = 4,
        Feed = 5,
        Project = 6,
        Unit = 7,
        Video = 8,
        Instagram = 9,
        CustomAudience = 10,
    }

    export enum ConversationType {
        SinglePerson = 1,
        MultiplePeople = 2,
        Group = 3,
    }

    export enum InformationFeedTemplate {
        NotSet = 0,
        Small = 1,
        Medium = 2,
        Large = 3,
        OnlyText = 4,
    }

    export enum ViewMode {
        Unset = 0,
        Small = 1,
        Medium = 2,
        Large = 3,

        PhonePortrait = 320,
        TabletPortrait = 768,
        PhoneLandscape = 960,
        TabletLandscape = 1024,
        SmallestLaptop = 1200,
        SmallLaptop = 1366,
        MediumLaptop = 1440,
        FullSize = 1560,
    }

    export enum BlogPostType {
        Image = 1,
        Video = 2,
        Podcast = 3,
    }

    export enum NewsFeedType {
        BigNewsArticles = 1,
        SmallNewsArticles = 2,
        ListView = 3
    }

    export enum MediaFileType {
        Image = 0,
        Video = 1,
        Audio = 2,
    }

    export enum FileStatus {
        Uploading = 0,
        Uploaded = 1,
        Encoding = 2,
        Done = 3,
        Error = 4,
        Undefined = 5,
    }

    export enum EventCategory {
        None = 0,
        Previous = 1,
        Upcoming = 2,
        Attending = 3,
    }

    export enum CalendarType {
        Public = 0,
        Project = 1,
        Personal = 2,
        Department = 3,
        Object = 4,
        Outlook = 5,
        Google = 6,
    }

    export enum UnitType {
        Office = 1,
        Department = 2,
        Company = 3,
    }

    export enum FileType {
        Undefined = 1,
        Pdf = 2,
        Mp3 = 3,
        Jpg = 4,
        Xls = 5,
        Xlsx = 6,
        Doc = 7,
        Docx = 8,
        Png = 9,
        Ppt = 10,
        Pptx = 11,
        Zip = 12,
        Gif = 13,
        Wav = 14,
        Rtf = 15,
        Html = 16,
        Txt = 17,
        Csv = 18,
        Pps = 19,
        Ods = 20,
        Odt = 21,
        Odp = 22,
        Sxw = 23,
        Sxc = 24,
        Sxi = 25,
        Aac = 26,
        M4a = 27,
        Webm = 28,
        Mp4 = 29,
    }

    export enum StartPageBuilderMode {
        Edit = 1,
        DesktopPreview,
        ResponsivePreview
    }

    export enum FolderRootSource {
        Upload = 0,
        SpintrPublic = 1,
        SpintrPrivate = 2,
        SpintrGroup = 3,
        Office365Public = 4,
        Office365Private = 5,
        Office365Group = 6,
        GoogleDrive = 7,
        SharePointSearch = 9,
        Canea = 10,
    }

    export enum FeedType {
        Unknown = 0,
        General = 1,
        User = 2,
        Group = 3,
        Dump = 4,
        Unused1 = 5,
        Unit = 6,
        SystemStatus = 7,
    }

    export enum GroupFunction {
        Chat = 0,
        Planning = 1,
        Notes = 2,
        Files = 3,
        Calendar = 4,
        Members = 5,
        Feed = 6,
        Support = 10,
        Timeline = 11,
    }

    export enum GroupAvailability {
        Open    = 1,
        Closed  = 2,
        Secret  = 3,
    }

    export enum UberContentSectionState {
        IsDisplayed = 0,
        IsEditing = 1,
        IsSelectingType = 2,
        IsDisplayingPlusSign = 3
    }

    export enum UberContentSectionType {
        Text = 0,
        Image = 1,
        IFrame = 2,
        Graph = 3,
        Form = 4,
        File = 5,
        DataWidget = 6,
        TeaserBox = 7,
        Calendar = 8,
        ExpandableField = 9,
        Link = 10,
        Direkten = 11,
        Preamble = 12,
        UserList = 13,
        Products = 14,
        TaxiFiles = 15,
        Video = 16,
        AcademyQuestion = 17,
        AcademyTask = 18,
        AcademyCourse = 19,
        NewsFeed = 20,
        AcademySession = 21,
        HighlightedText = 22,
        Divider = 23,
    }

    export enum TeaserBoxType {
        HeadingAndText = 1,
        HeadingAndIcon = 2,
        HeadingOnly = 3,
        Blog = 4,
        SjWidget = 5,
        Iframe = 6,
        DataWidget = 7,
        ImageOnly = 8
    }
    export enum TeaserBoxFilter {
        All = 0,
        TeaserBoxes = 1,
        DataWidgets = 2,
        Blogs = 3,
        TextPages = 4,
        Shortcuts = 5,
        StartPage = 6
    }

    export enum TeaserBoxPosition {
        Shortcuts = 0,
        StartPage = 1,
        TextPages = 2
    }

    export enum BonusFileResultType {
        FileUploaded = 1,
        FileAlreadyExists = 2,
        FolderNotFound = 3,
        InvalidFileName = 4,
    }

    export enum RealtimeEventName {
        CalendarEventUpdated = "CalendarEvent:Updated",

        ChatMessageDeleted = "Chat.Message:Deleted",
        ChatMessageHasRead = "Chat.Message:HasRead",
        ChatMessageNew = "Chat.Message:New",
        ChatMessagePinned = "Chat.Message:Pinned",
        ChatMessageReaction = "Chat.Message:Reaction",
        ChatMessageUnpinned = "Chat.Message:Unpinned",
        ChatMessageUnreaction = "Chat.Message:Unreaction",

        CommentNew = "Comment:New",
        CommentUpdated = "Comment:Updated",

        ConversationLastRead = "Conversation.LastRead",
        ConversationTyping = "Conversation.Typing",

        EmergencyMessageNew = "EmergencyMessage:New",
        EmergencyMessageUpdated = "EmergencyMessage:Updated",

        FeedPostCreated = "Feed:Post:Created",
        FeedPostUpdated = "Feed:Post:Updated",

        GroupPlanningUpdated = "Group:Planning:Updated",
        GroupPlanningItemRemoved = "Group:PlanningItem:Removed",
        GroupMemberCountUpdated = "Group:MemberCountUpdated",

        LikeDeleted = "Like:Deleted",
        LikeNew = "Like:New",

        ObjectDelete = "Object:Delete",
        ObjectPin = "Object:Pin",
        ObjectHideToggle = "Object:HideToggle",

        OperatingInfoNew = "OperatingInfo:New",
        OperatingInfoUpdated = "OperatingInfo:Updated",

        PlannerItemCreated = "Planner:Item:Created",
        PlannerItemDeleted = "Planner:Item:Deleted",
        PlannerItemUpdated = "Planner:Item:Updated",
        PlannerFileAdded = "Planner:File:Added",

        QualityHubTaskListCreated = "QualityHub:TaskList:Created",
        QualityHubTaskListUpdated = "QualityHub:TaskList:Updated",
        QualityHubTaskListDeleted = "QualityHub:TaskList:Deleted",
        QualityHubTaskListGroupCreated = "QualityHub:TaskListGroup:Created",
        QualityHubTaskListGroupUpdated = "QualityHub:TaskListGroup:Updated",
        QualityHubTaskListGroupDeleted = "QualityHub:TaskListGroup:Deleted",
        QualityHubTaskListItemCreated = "QualityHub:TaskListItem:Created",
        QualityHubTaskListItemUpdated = "QualityHub:TaskListItem:Updated",
        QualityHubTaskListItemDeleted = "QualityHub:TaskListItem:Deleted",
        QualityHubTaskListItemStatusCreated = "QualityHub:TaskListItemStatus:Created",
        QualityHubTaskListItemStatusUpdated = "QualityHub:TaskListItemStatus:Updated",
        QualityHubTaskListItemStatusDeleted = "QualityHub:TaskListItemStatus:Deleted",
        QualityHubOperationalTargetCreated = "QualityHub:OperationalTarget:Created",
        QualityHubOperationalTargetUpdated = "QualityHub:OperationalTarget:Updated",
        QualityHubOperationalTargetDeleted = "QualityHub:OperationalTarget:Deleted",
        QualityHubPinReset = "QualityHub:Pin:Reset",

        PollVote = "Poll:Vote",

        TextPageUpdated = "TextPage:Updated",

        BunnyVideoReady = "Bunny:VideoReady",
    }

    export enum KeyCodes {
        Backspace = 8,
        Tab = 9,
        Enter = 13,
        Shift = 16,
        Ctrl = 17,
        Alt = 18,
        Pause = 19,
        CapsLock = 20,
        Escape = 27,
        Space = 32,
        PageUp = 33,
        PageDown = 34,
        End = 35,
        Home = 36,
        LeftArrow = 37,
        UpArrow = 38,
        RightArrow = 39,
        DownArrow = 40,
        Insert = 45,
        Delete = 46,

        Digit0 = 48,
        Digit1 = 49,
        Digit2 = 50,
        Digit3 = 51,
        Digit4 = 52,
        Digit5 = 53,
        Digit6 = 54,
        Digit7 = 55,
        Digit8 = 56,
        Digit9 = 57,

        a = 65,
        b = 66,
        c = 67,
        d = 68,
        e = 69,
        f = 70,
        g = 71,
        h = 72,
        i = 73,
        j = 74,
        k = 75,
        l = 76,
        m = 77,
        n = 78,
        o = 79,
        p = 80,
        q = 81,
        r = 82,
        s = 83,
        t = 84,
        u = 85,
        v = 86,
        w = 87,
        x = 88,
        y = 89,
        z = 90,

        LeftWindowLey = 91,
        RightWindowKey = 92,
        SelectKey = 93,

        Numpad0 = 96,
        Numpad1 = 97,
        Numpad2 = 98,
        Numpad3 = 99,
        Numpad4 = 100,
        Numpad5 = 101,
        Numpad6 = 102,
        Numpad7 = 103,
        Numpad8 = 104,
        Numpad9 = 105,
        Multiply = 106,
        Add = 107,
        Subtract = 109,
        DecimalPoint = 110,
        Divide = 111,

        F1 = 112,
        F2 = 113,
        F3 = 114,
        F4 = 115,
        F5 = 116,
        F6 = 117,
        F7 = 118,
        F8 = 119,
        F9 = 120,
        F10 = 121,
        F11 = 122,
        F12 = 123,

        NavigationLeft = 140,
        NavigationRight = 141,
        NavigationAccept = 142,
        NavigationUp = 138,
        NavigationDown = 139,

        NumLock = 144,
        ScrollLock = 145,
        SemiColon = 186,
        EqualSign = 187,
        Comma = 188,
        Dash = 189,
        Period = 190,
        ForwardSlash = 191,
        GraveAccent = 192,
        OpenBracket = 219,
        BackSlash = 220,
        CloseBraket = 221,
        SingleQuote = 222,
    };

    export enum ImageCropAspect {
        Wide = 2.95,
        UltraWide = 1000/170,
    }

    export enum InsightsType {
        Question = 1,
        SearchRelated = 2,
        SearchExpert = 3,
        SearchRecommended = 4,
        OpenedShortcuts = 5,
        ClickedShortcut = 6,
        ClickedTeaserbox = 7,
        OpenedOperatingInfo = 8,
        VisitedNewsArchive = 9,
        VisitedTeamsApp = 10
    }

    export enum LoginResponse {
        Success = 1,
        Error = 2,
        LockedOut = 3,
        FirstTime = 4,
        FirstTimeAD = 5,
        AuthenticatorRequired = 6,
    }

    export enum AuthenticationMechanisms {
        RFC6238TOTP = 1,
        SMS = 2,
    }

    export enum QuestionType
    {
        FreeText = 1,
        SimpleAnswer = 2,
        MultipleAnswer = 3,
        Scale = 4,
        File = 5,
        Date = 6,
        Description = 7,
        Value = 8,
        Table = 9,
    }

    export enum TranslateType {
        Undefined = 0,
        Title = 1,
        Content = 2,
        Preamble = 3,
        CommentPreview = 4,
        ExtraId = 5,
        AiSummary = 6,
        WikiSectionTitle = 7,
    }

    export enum GroupMembershipStatus {
        None = 0,
        Invited = 1,
        Member = 2,
        Administrator = 3,
    }

    export enum ReportType {
        Uber = 1,
        ChatMessage = 2,
    }

    export enum TranslationError {
        Failed = 0,
        RequestLimitExceeded = 1
    }

    export enum SystemStatusType {
        AllClear = 0,
        Ongoing = 1,
        Done = 2,
        Planned = 3,
        Information = 4
    }

    export enum UberDirectType {
        None = 0,
        Hidden = 1,
        Factchecker = 2,
        Approver = 3,
        Follower = 4,
        Publisher = 5,
        TeaserBoxDirect = 6,
        Editor = 7,
        ArticleManager = 8
    }

    export enum RecurrenceType {
        None = 0,
        Daily = 1,
        Weekly = 2,
        Monthly = 3,
        Yearly = 4,
    };

    /**
     * Represents the type of a task list.
     */
    export enum TaskListType {
        /**
         * Represents a list of tasks to be completed.
         */
        CheckList = 1,

        /**
         * Represents a list of routines or procedures to be followed.
         */
        RoutineList = 2,

        /**
         * Represents a list of actions to be taken.
         */
        ActionList = 3,
    };

    export enum TaskListTarget {
        /**
         * A list that belongs to a singular user.
         */
        Personal = 1,

        /**
         * A task list that belongs to a singular department or team.
         */
        SingleDepartment = 2,

        /**
         * A task list that belongs to multiple departments or teams.
         */
        Departments = 3,

        /**
         * A task list that belongs to a single office.
         */
        SingleOffice = 4,

        /**
         * A task list that belongs to multiple offices.
         */
        Offices = 5,
    };

    /**
     * Represents the status of a task list item.
     */
    export enum TaskListItemStatus {
        /**
         * The item has not been started yet.
         */
        NotStarted = 0,

        /**
         * The item is currently in progress.
         */
        InProgress = 1,

        /**
         * The item has been completed.
         */
        Completed = 2,

        /**
         * The item could not be completed.
         */
        Failed = 3,
    };

    /**
     * A flags enum representing the days of the week.
     */
    export enum DaysOfWeek {
        None =      0,
        Sunday =    1,
        Monday =    2,
        Tuesday =   4,
        Wednesday = 8,
        Thursday =  16,
        Friday =    32,
        Saturday =  64,

        All =       127, // All days of the week
        Weekdays =  62, // Monday to Friday
        Weekend =   65, // Saturday and Sunday
    }

    /**
     * Represents the different modes in which we present the Quality Hub
     * tasks list.
     */
    export enum QualityHubTasksListMode {
        Overview = 1,
        Execution,
        Creation,
        Customization,
    };

    /**
     * Represents the different types of items in Quality Hub.
     */
    export enum QualityHubItemType {
        Task = 1,
        Reminder = 2,
    };

    /**
     * Represents the different artifact data types in Quality Hub.
     */
    export enum QualityHubArtifactType {
        None = 0,
        Numerical = 1,
        Text = 2,
    };

    /**
     * A flags enum representing the different verification types.
     */
    export enum QualityHubVerificationType {
        /**
         * No verification enabled.
         */
        None = 0,

        /**
         * Reserved and currently unused.
         */
        Unused = 1,

        /**
         * Enables the user to upload an image for verification.
         */
        Image = 2,

        /**
         * Enables the user to upload a video for verification.
         */
        Video = 4,

        /**
         * Enables all currently supported verification types.
         */
        All = Image | Video
    }

    export enum NotificationType {
        Profile = 0,
        ImageTag = 1,
        Follow = 2,
        Comment = 3,
        Like = 4,
        CommentAfter = 5,
        TextTag = 6,
        ProjectMemberRequest = 7,
        ProjectMemberAccepted = 8,
        EventInvite = 9,
        Message = 10,
        FollowUser = 11,
        FileDecayed = 12,
        ProjectInvite = 13,
        ConnectionRequest = 14,
        ConnectionAccepted = 15,
        ProjectTodoAssigned = 16,
        ProjectMemberAcceptedInvite = 17,
        AzureVideoHasBeenProcessed = 18,
        UserJoinedEvent = 19,
        TodoExpired = 20,
        EventDeleted = 21,
        NewContentReview = 22,
        ContentReviewAccepted = 23,
        ContentReviewDeclined = 24,
        QAAnswered = 25,
        QACreated = 26,
        NoteShared = 27,
        NoteUpdated = 28,
        QAAnswerUpdated = 29,
        TextpageExpired = 35,
        ZippedFolderReady = 36,
        ReachCount = 37,
        ContentPublished = 38,
        ContentUnpublished = 39,
        ContentUpdated = 40,
        General = 41,
        ZippedFolderFailed = 50,
        InAppTips = 51,
        MessageReply = 53,
        FeedbackGiven = 54,
        QuestionExpert = 55,
        UserBlocked = 56,
        SystemStatusCreatedOngoing = 57,
        SystemStatusCreatedDone = 58,
        SystemStatusCreatedPlanned = 59,
        SystemStatusUpdatedOngoing = 60,
        SystemStatusUpdatedDone = 61,
        SystemStatusUpdatedPlanned = 62,
        PhoenixSurvey = 63,
        SystemStatusCreatedInformation = 64,
        ChatMessageReaction = 65,
    }

    export enum AssistantType {
        Duplicate = 0,
        Freshness = 1,
        AudienceFit = 2,
        StyleAccessibility = 3,
        SensitiveContent = 4,
        AiReadiness = 5,
    }

    export enum PlannerBoardType {
        Company = 1,
        Office = 2,
        Department = 3,
        Personal = 4,
        Custom = 5,
        Group = 6
    }

    export enum SystemStatusImpact {
        Unspecified = 0,
        Low = 1,
        Medium = 2,
        High = 3,
    }

    export enum AISearchFeedbackDisplayType {
        All = 1,
        Positive = 2,
        Negative = 3,
    }
}
